import CaseSearch from '@/modules/Dashboard/components/filterSection/CaseSearch.tsx';
import SettlementPeriodFilter from '@/modules/Dashboard/components/filterSection/SettlementPeriodFilter.tsx';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import { Box, Flex } from 'styled-system/jsx';
import WalletLayout from '../components/layouts/WalletLayout';
import WalletCaseList from '../components/transactionSection/WalletCaseList';
import WalletCreditList from '../components/transactionSection/WalletCreditList';
import WalletBottomSheet from '../components/walletBottomSheet/WalletBottomSheet';
import YearlyCard from '../components/walletCards/YearlyCard';
import { walletPeriodsQueryOptions } from '../queries/walletPeriods/walletPeriodsQueryOptions';

export default () => (
  <WalletLayout>
    <Wallet />
  </WalletLayout>
);

function Wallet() {
  const scrollRef = useRef<HTMLDivElement>(null);

  // undefined means "let the api decide": current year / default month
  const [selectedYear, setSelectedYear] = useState<number>();
  const [selectedMonth, setSelectedMonth] = useState<number>();

  const {
    data: periodsData,
    isError,
    isPlaceholderData,
  } = useQuery({
    ...walletPeriodsQueryOptions({ year: selectedYear }),
    placeholderData: keepPreviousData,
  });

  // previous data only keeps the year list available while another year loads
  const periods = isPlaceholderData ? undefined : periodsData?.periods;
  const year = isPlaceholderData ? selectedYear : periodsData?.year;
  const month = periods
    ? (selectedMonth ?? periodsData?.default_month)
    : undefined;

  return (
    <Flex flexDirection={'column'} overscrollBehavior={'none'}>
      <YearlyCard />
      <WalletBottomSheet contentRef={scrollRef}>
        <Flex
          flexDirection={'column'}
          gap={24}
          position={'sticky'}
          top={0}
          bgColor={'white'}
          zIndex={1}
        >
          <CaseSearch />
          <SettlementPeriodFilter
            years={periodsData?.years ?? []}
            year={year}
            month={month}
            periods={periods}
            currentPeriod={periodsData?.current_period}
            onYearChange={(nextYear) => {
              if (nextYear === year) return;
              setSelectedYear(nextYear);
              setSelectedMonth(undefined);
            }}
            onMonthChange={setSelectedMonth}
          />
        </Flex>
        {isError && 'بارگیری با مشکل مواجه شده است!'}
        {!!year && !!month && (
          <Box>
            <WalletCreditList year={year} month={month} />
            <WalletCaseList
              scrollRoot={scrollRef.current}
              year={year}
              month={month}
            />
          </Box>
        )}
      </WalletBottomSheet>
    </Flex>
  );
}
